import styled from 'styled-components'
import { TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment } from 'generated/graphql'
import TentativeScoringQuestionItemMobile from './TentativeScoringQuestionItem.mobile'

interface TentativeScoringQuestionListMobileProps {
  examGradingQuestions: TentativeScoringQuestionItemDesktop_ExamGradingQuestionFragment[]
}

const TentativeScoringQuestionListMobile = ({
  examGradingQuestions,
}: TentativeScoringQuestionListMobileProps) => {
  return (
    <StyledWrapper>
      {examGradingQuestions?.map((question) => {
        return (
          <TentativeScoringQuestionItemMobile
            key={`question-id-${question.id}-${question.seq}`}
            questionData={question}
          />
        )
      })}
    </StyledWrapper>
  )
}

export default TentativeScoringQuestionListMobile

const StyledWrapper = styled.ul`
  width: 100%;
  display: flex;
  flex-direction: column;
  margin: 16px 0px 24px;

  & > li:first-child {
    border-top: none;
  }
`
